import React from "react";
import { Grid } from "@mui/material";
import { EFontFamilies } from "@/shared/theme/theme";
import MxTypography from "@rf-l1/MxTypography";
interface MainDetailPriceProps {
  price:
    | {
        label: string;
        value: string | null;
      }[]
    | null
    | undefined;
}
const MainDetailPrice = (props: MainDetailPriceProps) => {
  return (
    <Grid container item xs={12} my={0.8} rowGap={0.8}>
      {props?.price?.map((item, i) => (
        <Grid container key={i} borderRadius={1}>
          <Grid item xs={12}>
            <MxTypography
              variant="caption"
              color="black"
              fontWeight={300}
              fontFamily={EFontFamilies.SECONDARY_FONT}
              textTransform="uppercase"
              children={item.label}
            />
          </Grid>
          <Grid item xs={12}>
            <MxTypography
              variant="h2"
              color="error.main"
              fontWeight={600}
              fontFamily={EFontFamilies.DEFAULT_FONT}
              children={item.value}
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default MainDetailPrice;
